import React from 'react';
import { SpinnerIcon } from '@/components/common/Utils';
import useGradesTableStore from './store/useGradesTableStore';
import useGradesTableData from './hooks/useGradesTableData';
import useIsStructureLoading from './hooks/useIsStructureLoading';
import useStudents from './hooks/queries/useStudents';
import StudentlessClassroomMessage from './StudentlessClassroomMessage';
import Table from './Table';

const GradesTableContent = () => {
  const classroom = useGradesTableStore(state => state.classroom);
  const { data: students } = useStudents(classroom?.id);
  const isStructureLoading = useIsStructureLoading();

  useGradesTableData();

  if (isStructureLoading) {
    return (
      <div className="tw-flex tw-justify-center tw-align-middle tw-text-5xl tw-pt-12">
        <SpinnerIcon />
      </div>
    );
  }

  if (!students.length) return <StudentlessClassroomMessage />;

  return <Table />;
};

export default GradesTableContent;
